export default "__VITE_ASSET__BquVQsLX__"